<template>
  <div>
    <div id="printArea" class="vx-card no-scroll-content p-5">
      <div class="print-hide flex justify-end">
        <vs-button
          color="secondary"
          @click="printNewWindow">인쇄</vs-button
        >
      </div>
      <calendar-view
        class="pb-12"
        ref="calendar"
        :items="items"
        itemTop="1.6em"
        itemContentHeight="2em"
        itemBorderHeight="3px"
        :show-date="showDate"
        :time-format-options="{ hour: 'numeric', minute: '2-digit' }"
        :draggable="false"
        :enable-drag-drop="true"
        :disable-past="false"
        :disable-future="false"
        :show-times="false"
        display-period-uom="month"
        :display-period-count="1"
        :starting-day-of-week="0"
        :class="themeClasses"
        :period-changed-callback="periodChanged"
        :current-period-label="useTodayIcons ? 'icons' : ''"
        :displayWeekNumbers="false"
        :enable-date-selection="true"
        :selection-start="selectionStart"
        :selection-end="selectionEnd"
        @mousedown.prevent
        @date-selection-start.stop="startSetSelection"
        @date-selection="setSelection"
        @date-selection-finish="finishSelection"
        @drop-on-date="onDrop"
        @click-date="onClickDay"
        @click-item="onClickItem"
        @click.native="clickCalendar"
      >
        <div slot="header" class="mb-4">
          <div class="vx-row no-gutter">
            <!-- Current Month -->
            <div class="vx-col w-full sm:my-0 my-3 flex justify-center order-last">
              <div class="flex items-center">
                <feather-icon :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'" @click="updateMonth(-1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | moment("YYYY MMMM") }}</span>

                <feather-icon :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'" @click="updateMonth(1)" svgClasses="w-5 h-5 m-1" class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <vs-popup id="writePopup" title="안전·보건 점검 계획" :active.sync="writePopup" >
      <div class="grid gap-4">
        <div class="w-full flex items-center gap-4">
          <span>날짜:</span>
          <div class="flex-1 font-semibold">{{selectDay}} ({{ get요일 }})</div>
        </div>
        <div class="w-full flex items-center gap-4">
          <span>점검 계획</span>
          <div class="flex-1 font-semibold text-right">
            기존({{newItems.filter(item => item.id).length}}개),
            신규({{newItems.filter(item => !item.id).length}}개),
            삭제({{selectedDayItems.filter( item => !newItems.find( newItem => newItem.id === item.id ) ).length}}개)
          </div>
        </div>
        <div class="grid gap-2">
          <div class="grid gap-2 overflow-y-auto" style="max-height: 600px; padding-bottom: 2px;">
            <div v-for="item in newItems" class="w-full flex items-center gap-2">
              <div class="flex-1">
                <ml-input class="w-full" v-model="item.title" placeholder="점검 계획을 입력하세요."/>
              </div>
              <div>
                <vs-button color="secondary" type="border" class="p-2" @click="onClickDelete(item)">
                  <feather-icon icon="Trash2Icon" style="width: 20px; height: 20px;" class="align-bottom" />
                </vs-button>
              </div>
            </div>
          </div>
          <div>
            <vs-button color="secondary" class="w-full px-6" @click="addItems">
              <feather-icon icon="PlusIcon" class="align-bottom" />
            </vs-button>
          </div>
        </div>
        <div class="flex items-center justify-end gap-4">
          <vs-button color="secondary" class="px-6"
                     :disabled="newItems.filter( item => item.title ).length === 0
                                && selectedDayItems.filter( item => !newItems.find( newItem => newItem.id === item.id ) ).length === 0"
                     @click="onClickSave">
            <feather-icon icon="SaveIcon" style="width: 20px; height: 20px; " class="mr-2 align-bottom" />
            저장
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { CalendarView, CalendarMathMixin } from "vue-simple-calendar";
import Datepicker from "vuejs-datepicker";
import VueCookie from "vue-cookie";
import moment from "moment";
import * as UiUtil from "@/util/UiUtil";

require("vue-simple-calendar/static/css/default.css");
require("vue-simple-calendar/static/css/holidays-us.css");

export default {
  name: "List137",
  components: {
    CalendarView,
    Datepicker,
  },
  mixins: [CalendarMathMixin],
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    useCreate() {
      return this.projectId > 0 && this.create;
    },

    themeClasses() {
      return {
        "theme-default": this.useDefaultTheme,
        "holiday-us-traditional": this.useHolidayTheme,
        "holiday-us-official": this.useHolidayTheme,
      };
    },

    simpleCalendarEvents() {
      return this.$store.state.calendar.events;
    },
    disabledDatesTo() {
      return { to: new Date(this.startDate) };
    },
    disabledDatesFrom() {
      return { from: new Date(this.endDate) };
    },
    calendarLabels() {
      // return this.$store.state.calendar.eventLabels
      return [];
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    heads() {
      return [{ name: "사업명" }, { name: "점검대상" }, { name: "소속명" }, { name: "부서명" }, { name: "작성자" }, { name: "계획일" }, { name: "작성일" }];
    },
    selectedDayItems () {
      return this.items.filter(item => {
        if (this.selectDay) {
          const itemDate = new Date(item.startDate).format('yyyy-MM-dd');
          return itemDate === this.selectDay;
        }

        return true;
      });
    },
    get요일 () {
      if (this.selectDay) {
        const dayNames = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
        const date = new Date(this.selectDay);
        return dayNames[date.getDay()];
      }
      return '';
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    }
  },
  data() {
    return {
      create: true,
      rootPath: "", // 프로젝트의 rootPath
      list: [],

      showDate: new Date(),
      id: 0,
      startDate: "",
      endDate: "",

      selectDay: "",
      items: [],
      newItems: [],

      calendarView: "month",

      useDefaultTheme: true,
      useHolidayTheme: false,
      useTodayIcons: false,
      selectionStart: null,
      selectionEnd: null,

      nav: {
        projectId: 0,
        orderTarget: "created_at",
        orderDirection: "desc",
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [],
      },

      writePopup: false,
    };
  },

  created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;
    this.initBreadcrumb();
    this.loadPostList();
  },
  mounted() {
    const el = this.$refs.calendar && this.$refs.calendar.$el
      ? this.$refs.calendar.$el
      : this.$refs.calendar;

    const opts = { capture: true, passive: false };

    el.addEventListener("mousemove", this.blockDragOnMove, opts);
    el.addEventListener("touchmove", this.blockDragOnMove, opts);
    el.addEventListener("selectstart", this.blockAll, opts);
    el.addEventListener("dragstart", this.blockAll, opts);

    el.style.userSelect = "none";
    el.style.webkitUserSelect = "none";
  },

  beforeDestroy() {
    const el = this.$refs.calendar && this.$refs.calendar.$el
      ? this.$refs.calendar.$el
      : this.$refs.calendar;

    const opts = { capture: true, passive: false };

    el.removeEventListener("mousemove", this.blockDragOnMove, opts);
    el.removeEventListener("touchmove", this.blockDragOnMove, opts);
    el.removeEventListener("selectstart", this.blockAll, opts);
    el.removeEventListener("dragstart", this.blockAll, opts);
  },

  methods: {
    // 드래그 상황에서만 차단 (클릭은 통과)
    blockDragOnMove(e) {
      // 마우스: 왼쪽 버튼이 눌린 채 이동 중이면 드래그로 간주
      const isMouseDrag = e instanceof MouseEvent && e.buttons === 1;

      // 터치: 멀티/이동 중이면 사실상 드래그
      const isTouchDrag =
        typeof TouchEvent !== "undefined" &&
        e instanceof TouchEvent &&
        e.touches &&
        e.touches.length >= 1;

      if (isMouseDrag || isTouchDrag) {
        this._killEvent(e);
      }
    },

    // 드래그/선택 시작 자체를 차단
    blockAll(e) {
      this._killEvent(e);
    },

    _killEvent(e) {
      // stopPropagation이 없는 상황도 대비
      if (typeof e.stopPropagation === "function") e.stopPropagation();
      if (typeof e.preventDefault === "function") e.preventDefault();
      // 레거시 브라우저/특수 객체 대비
      e.cancelBubble = true;
      return false;
    },
    clickCalendar(e) {
      if (e.target.tagName === "svg" || e.target.tagName === "polyline" || e.target.tagName === "SPAN") {
        this.loadPostList();
      }
    },
    initBreadcrumb() {
      if (this.projectId === 5) {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "안전·보건 점검 계획" }, { title: "시설물 안전점검 계획", active: true }]);
      }
    },
    getContent(data) {
      if (data.post_content) {
        try {
          const content = JSON.parse(data.post_content);
          if (content.body) {
            return content.body;
          }
          return content;
        } catch (e) {
          return {};
        }
      }
    },
    getDate(date) {
      return new Date(date).format("yyyy-MM-dd");
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.header;
      }
    },
    async loadPostList() {
      await this.loadBoardPostList();
    },

    async loadApprovalPostList() {
      const projectId = this.$route.params.proj_id;
      const boardSlug = "board-137";
      const page = 1;
      const perPage = 10000;

      await this.$store.dispatch("approval/LOAD_POST_ALL", { projectId, boardSlug, page, perPage });

      this.list = this.$store.state.approval.list;
      this.items = [];
      for (const data of this.list) {
        const content = this.getContent(data);
        if (content) {
          if (content.title) {
            this.items.push({
              id: data.id,
              startDate: new Date(content.stdInfo.계획일),
              endDate: new Date(content.stdInfo.계획일),
              title: content.title,
              classes: "success",
              raw: data,
            });
          }
          else if (content.group1 && content.group1.length > 0) {
            for (const group of content.group1) {
              this.items.push({
                id: `${data.id}_${group.target}`,
                startDate: new Date(content.stdInfo.계획일),
                endDate: new Date(content.stdInfo.계획일),
                title: `${group.target} - ${content.stdInfo.field_name}`,
                classes: "success",
                raw: data,
              });
            }
          }
        }
      }
    },

    async loadBoardPostList() {
      const projectId = this.$route.params.proj_id;
      const boardId = 137;
      const page = 1;
      const perPage = 10000;
      const dateTarget = "body.stdInfo.계획일";
      let dateBegin = moment().startOf("month").format("YYYY-MM-DD");
      let dateEnd = moment().endOf("month").format("YYYY-MM-DD");

      if (this.$refs.calendar) {
        dateBegin = moment(this.$refs.calendar.periodStart).subtract(1, 'month').startOf("month").format("YYYY-MM-DD");
        dateEnd = moment(this.$refs.calendar.periodStart).add(1, 'month').endOf("month").format("YYYY-MM-DD");
      }

      const conditions = []
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<=', value: dateEnd})

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, conditions });
      const postListInfo = this.$store.state.board.postListInfo;
      this.list = postListInfo.data;
      this.items = [];
      for (const data of this.list) {
        const content = this.getContent(data);

        if (content) {
          if (content.title) {
            this.items.push({
              id: data.id,
              startDate: new Date(content.stdInfo.계획일),
              endDate: new Date(content.stdInfo.계획일),
              title: content.title,
              classes: "success",
              raw: data,
            });
          }
          else if (content.group1 && content.group1.length > 0) {
            for (const group of content.group1) {
              this.items.push({
                id: `${data.id}_${group.target}`,
                startDate: new Date(content.stdInfo.계획일),
                endDate: new Date(content.stdInfo.계획일),
                title: `${group.target} - ${content.stdInfo.field_name}`,
                classes: "success",
                raw: data,
              });
            }
          }
        }
      }
    },

    getCol(index, value) {
      try {
        switch (index) {
        case 0:
          return this.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return this.getContentTargetList(this.getContent(value).group1); // 점검대상
        case 2:
          return this.getContent(value).stdInfo.department; // 소속명
        case 3:
          return this.getContent(value).stdInfo.section; // 부서명
        case 4:
          return this.getContent(value).stdInfo.writer_name; // 작성자
        case 5:
          return this.getContent(value).stdInfo.계획일; // 계획일
        case 6:
          return this.getDate(value.created_at); // 작성일
        }
      } catch (e) {
        /*ignore*/
      }
      return "";
    },

    getPreview(data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview);
        return preview;
      }
    },

    periodChanged() {
      // range, eventSource) {
      // Demo does nothing with this information, just including the method to demonstrate how
      // you can listen for changes to the displayed range and react to them (by loading items, etc.)
      //console.log(eventSource)
      //console.log(range)
    },
    thisMonth(d, h, m) {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0);
    },
    onClickDay(date) {
      this.selectDay = new Date(date).format('yyyy-MM-dd')
      this.newItems = Object.assign([], this.selectedDayItems);
      if (this.newItems.length === 0) { this.addItems();}
      this.writePopup = true;
    },
    onClickItem(data) {
      this.selectDay = new Date(data.startDate).format('yyyy-MM-dd')
      this.newItems = Object.assign([], this.selectedDayItems);
      if (this.newItems.length === 0) { this.addItems();}
      this.writePopup = true;
    },
    addItems () {
      this.newItems.push({
        id: 0,
        title: "",
      });
    },
    onDrop(item, date) {
      const message = `You dropped ${item.id} on ${date.toLocaleDateString()}`;
      // Determine the delta between the old start date and the date chosen,
      // and apply that delta to both the start and end date to move the item.
      const eLength = this.dayDiff(item.startDate, date);
      item.originalItem.startDate = this.addDays(item.startDate, eLength);
      item.originalItem.endDate = this.addDays(item.endDate, eLength);

      UiUtil.alertDialog(message);
    },
    startSetSelection(dateRange) {
      this.selectionEnd = dateRange[1];
      this.selectionStart = dateRange[0];
      //this.handleClickRegister(this.selectionStart);
    },
    setSelection(dateRange) {
      this.selectionEnd = dateRange[1];
      this.selectionStart = dateRange[0];
    },
    finishSelection(dateRange) {
      this.setSelection(dateRange);
      const message = `You selected: ${this.selectionStart.toLocaleDateString()} -${this.selectionEnd.toLocaleDateString()}`;
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },

    handleClickRegister(date) {
      this.selectDay = date;
      if (this.selectDay) {
        const d = new Date(this.selectDay).format("yyyy-MM-dd");
        VueCookie.set("list137_selectday", d);
        this.$router.push({
          name: "write|tab",
          params: {
            boardId: 137,
            pageType: 'write'
          },
        });
      }
    },

    handleItemClickDetail(data) {
      const raw = data.originalItem.raw;
      const boardId = raw.board_id;
      const postId = raw.id;
      const pageType = "write";
      this.$router.push({
        name: "write|update|tab",
        params: { boardId, postId, pageType },
      });
    },

    onChangeSearch(value) {
      this.nav.value = value;
      this.initSearchKeyValue();
    },

    initSearchKeyValue() {
      const keyValue = this.getSearchKeyValue137();
      let keyword = this.getSearchKeyword137();

      if (keyword) {
        keyword = keyword.map((_keyword) => {
          return _keyword.replace("default_skw", `nav.page.p${this.$route.params.boardId}.searchKeyword`).replace("default_disaster", `nav.page.p${this.$route.params.boardId}.disasterType`);
        });
      }

      this.nav.page[`p${this.boardId}`] = keyValue;
      this.nav.keyword = keyword;
    },
    getSearchKeyValue137() {
      if (this.nav.value.created_at) {
        this.nav.dateTarget = "created_at";
        this.nav.dateBegin = "nav.value.created_at.sDate";
        this.nav.dateEnd = "nav.value.created_at.eDate";
      }
      return { searchType: this.nav.value.searchType, searchKeyword: this.nav.value.searchKeyword };
    },
    getSearchKeyword137() {
      const returnData = [];

      switch (this.nav.value.searchType) {
      case "사업명":
        returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
        break;
      case "소속명":
        returnData.push("content$body.stdInfo.department*%[:default_skw]%");
        break;
      case "부서명":
        returnData.push("content$body.stdInfo.section*%[:default_skw]%");
        break;
      case "작성자":
        returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
        break;
      }

      return returnData;
    },
    getContentTargetList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },

    onClickDelete (item) {
      const index = this.newItems.indexOf(item);
      if (index > -1) {
        this.newItems.splice(index, 1);
      }
    },
    async onClickSave () {
      try {
        UiUtil.loading(true);

        // 신규
        const newPlans = this.newItems.filter( item => !item.id && item.title );

        // 업데이트
        const updatePlans = this.newItems.filter( item => item.id && item.title );

        // 삭제
        const deletePlans = this.selectedDayItems.filter( item => !this.newItems.find( newItem => newItem.id === item.id ) );

        // 기본정보
        const options = {
          form: {
            header: {
              year: parseInt(this.selectDay.split('-')[0]),
              month: parseInt(this.selectDay.split('-')[1]),
              day: parseInt(this.selectDay.split('-')[2]),
              full: this.selectDay,
            },
            body: {
              stdInfo: {
                company_id: this.myInfo.company_id,
                rank: this.myInfo.rank,
                section: this.myInfo.section,
                writer_name: this.myInfo.name,
                계획일: this.selectDay,
              },
              group1: [],
              fileList: [],
              title: "",
            }
          }
        }

        await this.writeSaveBoardPost('create', newPlans, options)
        await this.writeSaveBoardPost('update', updatePlans, options)
        await this.deleteBoardPost(deletePlans)

      } catch (error) {

      } finally {
        UiUtil.loading(false);
        await this.loadPostList()
        this.writePopup = false;
      }
    },

    async writeSaveBoardPost(type, plans, options) {
      for (const item of plans) {
        const form = JSON.parse(JSON.stringify(options.form));
        form.body.title = item.title; // 팝업에서 입력한 점검 계획을 넣는다.
        const projectId = this.projectId;
        const boardId = 137;
        const title = form.body.title;
        const content = JSON.stringify(form);

        if (type === "create") {
          await this.$store.dispatch("board/CREATE_POST", {
            projectId,
            boardId,
            title,
            content,
          });
        } else if (type === "update") {
          const postId = item.raw.id;
          await this.$store.dispatch("board/UPDATE_POST", {
            projectId,
            boardId,
            postId,
            title,
            content,
          });
        }
      }
    },
    async deleteBoardPost(plans) {
      for (const item of plans) {
        const boardId = 137;
        const postId = item.raw.id;
        await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
      }
    },

    printNewWindow() {
      const printContents = document.getElementById('printArea').innerHTML;
      const win = window.open('', '_blank', 'width=1200,height=900');
      const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(node => node.outerHTML)
        .join("\n");

      win.document.write(
        `
          <html>
            <head>
              <title>안전·보건 점검 계획 - 인쇄</title>
              ${styles}
              <style>
                /* ✅ 필요한 스타일만 추가 */
                body {
                  font-family: Arial, sans-serif;
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }

                /* vue-simple-calendar 스타일이 필요하다면 import */
                @import url("https://unpkg.com/vue-simple-calendar/static/css/default.css");

                @page {
                  size: A4 landscape;
                  margin: 10mm;
                }

                /* 페이지 꽉 차게 정렬 */
                #printWrapper {
                  width: 100%;
                }
              </style>
            </head>
            <body>
              <div id="printWrapper">
                ${printContents}
              </div>
            </body>
          </html>
        `
      );

      win.document.close();
      win.onload = () => {
        win.focus();
        win.print();
        win.close(); // 인쇄 후 창 닫기 (원하면 활성화)
      }
    },
  }
};
</script>

<style>
.theme-default .cv-weekdays .cv-item.success {
  border-color: transparent;
  background-color: transparent;
  color: #3c3c3c;
}

.theme-default .cv-item.none {
  border-color: rgb(255, 159, 67);
  background-color: rgb(255, 159, 67);
  color: #fff;
}
.theme-default .cv-weekdays .cv-item.success {
  font-weight: 400;
  border-radius: 3px;
  display: inline-flex; /* 세로 정렬하기 위해 display 속성 변경 */
  align-items: center;
  height: 2em; /* itemContentHeight 값과 동일하게 설정해야 한다*/
}

/* 날짜 박스 내에서, 이벤트 박스의 가로 길이를 정한다. -xxem 만큼 여백이 생긴다.
offset 클래스와 조합해서 양쪽 여백을 생성해야 한다 */
.theme-default .cv-item.span1 {
  width: calc((100% / 7) - 0.6em);
}
/*이벤트 박스의 왼쪽 바깥 여백은 calc 내의 + xxem 값으로 조정된다*/
.theme-default .cv-item.offset1 {
  left: calc((100% / 7) + 0.3em);
}
.theme-default .cv-item.offset2 {
  left: calc((200% / 7) + 0.3em);
}
.theme-default .cv-item.offset3 {
  left: calc((300% / 7) + 0.3em);
}
.theme-default .cv-item.offset4 {
  left: calc((400% / 7) + 0.3em);
}
.theme-default .cv-item.offset5 {
  left: calc((500% / 7) + 0.3em);
}
.theme-default .cv-item.offset6 {
  left: calc((600% / 7) + 0.3em);
}

.theme-default .cv-header-day {
  padding: 1rem;
}

.theme-default .cv-day[aria-selected] {
  background-color: #6670cb;
  color: #fff;
}


</style>


<style>
@media print {
  .print-hide {
    display: none !important;
  }
  /* ✅ 달력 이벤트 텍스트 색상 강제 변경 */
  .cv-item,
  .cv-item * {
    color: #000 !important;
    fill: #000 !important; /* 아이콘(svg)도 포함 */
  }

  /* 배경을 유지하고 싶지 않다면 (없애고 싶으면 주석 해제)
  .cv-item {
    background: transparent !important;
    border-color: #000 !important;
  }
  */
}
</style>
